import { createFeatureSelector, createSelector } from '@ngrx/store';

import { LoadableLibraryAvailability } from './library-availability';

export const STATE_LIBRARY_AVAILABILITY = 'libraryAvailability';

export type LibraryAvailabilityState = {
  [resourceId: string]: LoadableLibraryAvailability;
};

export const LIBRARY_AVAILABILITY_INITIAL_STATE: LibraryAvailabilityState = {};

export const selectLibraryAvailabilityState =
  createFeatureSelector<LibraryAvailabilityState>(STATE_LIBRARY_AVAILABILITY);

export const getLibraryAvailabilityForResourceId =
  (resourceId: string) => (state: LibraryAvailabilityState) =>
    (state && state[resourceId]) || null;

export const selectLibraryAvailabilityForResourceId = (resourceId: string) =>
  createSelector(
    selectLibraryAvailabilityState,
    getLibraryAvailabilityForResourceId(resourceId),
  );

export function getInitialLibraryAvailabilityState(): LibraryAvailabilityState {
  return LIBRARY_AVAILABILITY_INITIAL_STATE;
}
